import { HttpClient } from "@angular/common/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {PortalsTranslationConfig} from "./portals-translation.module";

export function HttpLoaderFactory(http: HttpClient, config: PortalsTranslationConfig): TranslateHttpLoader {
    return new TranslateHttpLoader(http, config.translationsDeployUrl);
}
